/**
 * Citadel admin plane — entry point.
 *
 * Sprint: SPR-26.O | BL-29-1790
 * See docs/architecture/Citadel_Architecture_ADR.md
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import App from './App';
import './styles/index.css';

const domain = import.meta.env.VITE_AUTH0_DOMAIN ?? 'rodiun.uk.auth0.com';
const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID ?? '';
// BL-29-1790 phase 1: shared audience with platform-ui ('https://api.rodiun.io').
// Operon's shared-go/middleware/jwt_auth.go validates against EXACTLY ONE
// audience; phase 2 (BL-29-1798) introduces multi-audience support and
// switches the default below to 'https://citadel.rodiun.io'. See
// docs/architecture/Citadel_Architecture_ADR.md §Audience note for the
// architectural rationale.
const audience =
    import.meta.env.VITE_AUTH0_AUDIENCE ?? 'https://api.rodiun.io';

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <Auth0Provider
            domain={domain}
            clientId={clientId}
            authorizationParams={{
                redirect_uri: window.location.origin,
                audience,
                scope: 'openid profile email offline_access',
            }}
            cacheLocation="localstorage"
            useRefreshTokens
        >
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </Auth0Provider>
    </React.StrictMode>,
);
